export default __webpack_public_path__ + "static/media/proclamation7.9e96437c.jpg";